import { Icon, IconsEnum } from 'components/Icons';

import { DynamicImage, enLoading } from 'components/Image';
import { ImageProps } from 'next/image';
import { ItemWithTranslation } from 'types/swagger';
import { isNotEmpty } from 'utility/functions';
import { selectMenuManifestazioni } from 'features/sport/selectors';
import styles from './SportManifestazioneHeaderTitle.module.scss';
import { useAddManifestazioneToPreferitiMutation } from 'features/api/sportApiSlice';
import { useInternalSession } from 'hooks/useInternalSession';
import { useTranslation } from 'hooks/useLingUI';
import { useTypedSelector } from 'lib/centralStore';

export type SportManifestazioneHeaderTitleProps = ItemWithTranslation<{ gruppo?: string; manifestazione?: string }> & {
  image?: ImageProps;
  idManifestazione: number;
  slugManifestazione?: string;
};

export const SportManifestazioneHeaderTitle = ({
  image,
  gruppo,
  gruppoTrKey,
  manifestazione,
  idManifestazione,
  slugManifestazione,
  manifestazioneTrKey,
}: SportManifestazioneHeaderTitleProps) => {
  const { t } = useTranslation();
  const { isAuthenticated } = useInternalSession();
  const [addManifestazioneToPreferiti] = useAddManifestazioneToPreferitiMutation();

  const { preferiti } = useTypedSelector(selectMenuManifestazioni);

  return (
    <div className={styles.container}>
      <div className={styles.paragraph}>
        {isNotEmpty(image?.src) && (
          <div className={styles.imageContainer}>
            <DynamicImage
              src={`${image?.src}`}
              alt={image?.alt ?? ''}
              title={image?.title ?? ''}
              fill
              loading={enLoading.lazy}
              decoding="async"
              className={styles.country}
            />
          </div>
        )}

        <span className={styles.text}>{t(gruppoTrKey, gruppo)}</span>
      </div>
      <div className={styles.titleContainer}>
        {isAuthenticated && (
          <button
            type="button"
            className={styles.button}
            disabled={!idManifestazione}
            onClick={() => {
              addManifestazioneToPreferiti({
                id: String(idManifestazione),
                slug: slugManifestazione,
                descrizione: manifestazione ?? '',
              });
            }}
          >
            <Icon
              iconId={preferiti?.some((item) => item.slug === slugManifestazione) ? IconsEnum.FULL_PIN : IconsEnum.PIN}
              className={styles.pin}
              color={
                preferiti?.some((item) => item.slug === slugManifestazione)
                  ? 'var(--color-primary)'
                  : 'var(--color-on-bg-primary'
              }
            />
          </button>
        )}
        <h2 className={styles.title} suppressHydrationWarning={true}>
          {t(manifestazioneTrKey, manifestazione)}
        </h2>
      </div>
    </div>
  );
};
